import React, { useState, useContext } from 'react'
import {MealBuddyChat} from './MealBuddyChat.jsx'
import useLocalStorage from '../hooks/useLocalStorage'
import {registerContext} from '../hooks/contextAPI'
import img from '../images/login-icon.png'
import img2 from '../images/unnamed.jpg'
import img3 from '../images/people.jpg'
import {context2} from '../hooks/contextAPI'

export const Register = React.memo(React.forwardRef((props, ref) => {

    const showVideo = useContext(context2)
    const [show, setShow] = useState(false)
    const [submit, setSubmit] = useState(false)
    const [email, setEmail] = useLocalStorage('Email', '')
    const [place, setPlace] = useLocalStorage('Location', '')
    const [age, setAge] = useLocalStorage('Age', '')
    const [id, setId] = useLocalStorage('Name', '')
    const [ingr, setIngr] = useState('')
    const [text, setText] = useState('')


    const nameChange = (e) => {
        
        if (id !== "" && email !== "" && email.includes('@') && place !== "" && age !== "" && ingr !== "") {
            setShow(true)
            setSubmit(true)
        }
        
        if(id === '' || email === '' || ingr === '' || age === '' || place === ''){
            setText('Invalid Input')
        }else{
            setText('')
        }   
    }

    return (
        <>  
            <div className="register-div" ref={ref}>
                <div class="chat-header">
                    <h1> Meet Your Next Meal Buddy </h1>
                    <div className="chat-inner">
                        <p> Choose your favourite restaurant </p>
                        <span className="dot"> </span>
                        <p> Interact with your buddy </p>
                        <span className="dot"> </span>
                        <p> Have a perfect meal date </p>
                    </div>
                </div>
                {!submit && <div className="inner-div">
                    <div className="inner-input-div">
                        <img src = {img} alt = "" className = "login-icon"/>
                        <p style = {{color: 'red'}}> {text} </p>
                        <div>
                            <p> Name </p>
                            <input placeholder="Enter your name" onChange={e => setId(e.target.value)} />
                        </div>
                        <div>
                            <p> Email </p>
                            <input placeholder="Enter your email" onChange={e => setEmail(e.target.value)} />
                        </div>
                        <div>
                            <p> Current Residence </p>
                            <input placeholder="Enter your city of residence" onChange={e => setPlace(e.target.value)} />
                        </div>
                        <div>
                            <p> Age </p>
                            <select className="age-select" onChange={e => setAge(e.target.value)}>
                                <option value="" select hidden> --Age Level-- </option>
                                <option value="child"> Child(7-12) </option>
                                <option value="teen"> Teenager(13-19) </option>
                                <option value="adult"> Adult(20-59) </option>
                                <option value="senior"> Senior(60+) </option>
                            </select>
                        </div>
                        <div>
                            <p> Favourite ingredient </p>
                            <input placeholder="Enter your favourite" onChange={e => setIngr(e.target.value)} />
                        </div>
                        <button onClick={nameChange} className = "submit-btn btns"> Submit </button>
                    </div>
                    {!submit && <div className = "image-stack"> <img src = {img2} alt = "" className = "register-circle-1" /> <img src = {img3} alt = "" className = "register-circle-2"/> </div>}

                </div>}
                {submit && show && <registerContext.Provider value = {{submit, setSubmit}}>  <MealBuddyChat info = {[age, place, id, ingr, place]}/>  </registerContext.Provider>}
            </div>
        </>

    )
}))
